exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.noHit {\n  text-align:center;\n  margin:4ex;\n  font-size:200%;\n  font-weight:bold;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /GIT/Search-manager/rating-module/src/app/pages-box/pages-box.component.css
// module id = ../../../../../src/app/pages-box/pages-box.component.css
// module chunks = main